import { Box, Button, Grid, InputBase } from "@mui/material"
import { AddRoundIcon, EditProfile, SearchIcons } from "../../../../../core/global/Icons"
import { useHistory } from "react-router-dom"
import { PrimaryToolTip } from "../../../../../core/global/ToolTip"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { CstmSnackBar } from "../../../../../core/global/forms/CstmSnackBar"
import { BranchProductRead } from "../../../global/API"
import { ListLoader } from "../../loader/ListLoader"
import { NoDataFound } from "../../../empty/Index"
import { Waypoint } from "react-waypoint"
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader"
import { isNumeric } from "../../../../../core/global/Format"

export const List = ({loader, setLoader}) => {
    const nav = useHistory()
    const { tool_state, setup_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const { branchProductList, branchProductSearchList, searchInput, listLoader, infiniteState } = setup_state

    const redirectionHandler = async(type, value) => {
        infiniteState.set((prev) => ({...prev, offset:0}))
        setLoader({...loader, snackbar:false, msg:''})
        await branchProductList.set([])
        await branchProductSearchList.set([])
        nav.push(`/setup/branch-product/${type === 'create' ? type : window.btoa(JSON.stringify(value))}`)
    }

    const loadMoreData = async() => {
        if (infiniteState.data.offset > 0) {
            __init(infiniteState.data.offset, infiniteState.data.dataType )
        }
    }

    const __init = async(offset=0, dataType='string') => {
        if (offset === 0) {
            listLoader.set((prev) => ({...prev.data, isloading:true}))
            infiniteState.set((prev) => ({...prev, infiniteLoad:true}))
        }
        let qsp = {
            company_id: __SESSION.data.uaccess[0].company_id, 
            filter:'all',
            limit:infiniteState.data.limit,
            offset:offset,
            search:searchInput.data,
            dataType:dataType
        }
        let res = await BranchProductRead(qsp)
        if (res) {
            if (res.length === 0) {
                infiniteState.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
            }else{
                ///// LOADER VALIDATION
                if (res.length < infiniteState.data.limit) {
                    infiniteState.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
                }else{
                    infiniteState.set((prev) => ({...prev, offset:res.length + branchProductList.data.length}))
                }
                ///// STATE LIST DATA
                if (searchInput.data === '') {
                    branchProductList.set([...branchProductList.data, ...res])
                }else{
                    branchProductSearchList.set([...branchProductSearchList.data, ...res])
                }
            }   
            listLoader.set((prev) => ({...prev.data, isloading:false}))
        }
    }

    const searchHandler = () => {
        let numeric = isNumeric(searchInput.data) ? 'integer' : 'string'
        infiniteState.set((prev) => ({...prev, dataType:numeric }))
        __init(0, numeric)
        listLoader.set((prev) => ({...prev.data, isloading:false}))
    }

    useEffect(() => {
        if (!listLoader.data.isloading) {
            listLoader.set((prev) => ({...prev.data, isloading:true}))
        }
        branchProductList.set([])
        branchProductSearchList.set([])
        const searchFcn = setTimeout(() => {
            if (searchInput.data === '') {
                __init(0, 'string')
                listLoader.set((prev) => ({...prev.data, isloading:false}))
            }else{
                searchHandler()
            }
        }, 500);
        return () => clearTimeout(searchFcn)
        //eslint-disable-next-line
    }, [searchInput.data])
    return (
        <Box height="100%" width="100%" bgcolor="#FFFFFF" borderRadius="12px" display="flex" flexDirection="column" p={3}>
            <Box minHeight="120px" display="flex" flexDirection="column" gap={3}>
                <Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
                    <InputBase
                        onInput={(e)=> searchInput.set(e.target.value)}
                        value={searchInput.data}
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search' }} endAdornment={ <Box pr={1} pt={1}><SearchIcons /></Box> }
                        sx={{backgroundColor: "#FFFFFF", border: "#D9EBE8 solid 2px", borderRadius: '10px', padding: '5px 5px 5px 20px', width: '291px', height: '49px'}}
                    />
                    <Box onClick={()=>redirectionHandler('create')} component={Button} disableFocusRipple={true} minHeight="50px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="primary.main" color="#fff" sx={{border:"2px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}} startIcon={<AddRoundIcon/>} px={3}>
                        <Box fontSize={16} fontWeight={400} lineHeight="19px">Branch Product</Box>
                    </Box>
                    
                </Box>
                <Grid container direction="row" sx={{px:2}}>
                    <Grid item xs={3}>Branch</Grid>
                    <Grid item xs={3}>Product</Grid>
                    <Grid item xs={1.5} textAlign="center">Qty</Grid>
                    <Grid item xs={1.5} textAlign="center">Price</Grid>
                    <Grid item xs={1} textAlign="center">Visible</Grid>
                    <Grid item xs={1} textAlign="center">Status</Grid>
                    <Grid item xs={1} textAlign="center">Action</Grid>
                </Grid>
            </Box>

            <Box height="100%" width="100%" className="overflowY" display="flex" flexDirection="column" gap="12px">
                {listLoader.data.isloading && <ListLoader/>}
                {(!infiniteState.data.infiniteLoad && !listLoader.data.isloading && ( searchInput.data === '' ? branchProductList.data.length === 0 : branchProductSearchList.data.length === 0 ) ) && <NoDataFound/>}
                {!listLoader.data.isloading && ( searchInput.data === '' ? branchProductList.data: branchProductSearchList.data ).map((v,k) => (
                    <Grid key={k} container direction="row" sx={{p:2, border:'1px solid #EBEBEB', borderRadius:'10px'}}>
                        <Grid item xs={3}>{v.branch_name}</Grid>
                        <Grid item xs={3}>{v.alias === null || v.alias === "None" || v.alias.trim() === ''  ? v.sub_category_name + " " + v.product_name :  v.alias}</Grid>
                        <Grid item xs={1.5} textAlign="center">{parseFloat(v.quantity)}</Grid>
                        <Grid item xs={1.5} textAlign="center">₱ {parseFloat(v.price).toFixed(2)}</Grid>
                        <Grid item xs={1} textAlign="center">{v.visible === 1 ?"Visble":"Invisible"}</Grid>
                        <Grid item xs={1} textAlign="center">{v.active === 1 ?"Active":"Inactive"}</Grid>
                        <Grid item xs={1} textAlign="center">
                            <PrimaryToolTip onClick={()=>redirectionHandler('edit', v)} title="Update" arrow sx={{margin: '0 14px 0 14px'}} placement="top">
                                <Box fontWeight={500} className="c-pointer">
                                    <EditProfile fill={'none'} stroke={'#292d32'}/>
                                </Box>
                            </PrimaryToolTip>
                        </Grid>
                    </Grid>
                ))}
                 {(infiniteState.data.infiniteLoad && !listLoader.data.isloading) && (
                    <Grid item xs={12} container direction="row" justifyContent="center">
                        <Waypoint onEnter={loadMoreData} >
                            <Box component="strong" mt={5} display="flex" justifyContent="center">
                                <SnakeLoader size="10px" bg="#11783C" distance="0.3rem" />
                            </Box>
                        </Waypoint>
                    </Grid>
                )}
            </Box>
            {loader.snackbar && (
                <CstmSnackBar value={loader} setter={setLoader} msg={loader.msg} type='success' /> 
            )}
        </Box>
    )
}